exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".header[data-v-420c3e29]{color:#6c6c75;font-size:1.8461538462rem;font-weight:bold}section>h3[data-v-420c3e29]{margin-top:16px}", ""]);

// exports
